import { create } from "zustand";

/**
 * Akıllı tasarım sihirbazı ve adım çubuğu durumu (Cem 2026-10-06: "programımız yönlendirsin doğru yola").
 * - `open(wallId)`: "✨ Akıllı tasarımla başla" penceresi proje içinden, o duvara yazacak kipte açılır (CadShell'de monte).
 * - `soilDone` / `reportSeen`: adım çubuğunun ① ve ④ tamamlanma bilgisi (oturum içi).
 * - `stepperHidden`: kullanıcı adım çubuğunu ✕ ile kapattı (localStorage; sihirbaz açılınca yeniden görünür).
 */
const HIDE_KEY = "tasduvar.stepper-hidden";
const readHidden = (): boolean => { try { return localStorage.getItem(HIDE_KEY) === "1"; } catch { return false; } };
const writeHidden = (on: boolean): void => { try { if (on) localStorage.setItem(HIDE_KEY, "1"); else localStorage.removeItem(HIDE_KEY); } catch { /* özel pencere */ } };

export interface WizardState {
  /** Sihirbaz açık: hedef duvar (null = kapalı) */
  wallId: string | null;
  open(wallId: string): void;
  close(): void;
  /** Sihirbazın (ya da yeni projede akıllı başlangıcın) uygulandığı duvarlar */
  soilDone: Record<string, true>;
  markSoil(wallId: string): void;
  /** Raporu (ya da Çizim paftasını) en az bir kez açılmış projeler */
  reportSeen: Record<string, true>;
  markReport(projectId: string): void;
  stepperHidden: boolean;
  setStepperHidden(on: boolean): void;
}

export const useWizardStore = create<WizardState>((set) => ({
  wallId: null,
  open: (wallId) => { writeHidden(false); set({ wallId, stepperHidden: false }); },
  close: () => set({ wallId: null }),
  soilDone: {},
  markSoil: (wallId) => set((s) => (s.soilDone[wallId] ? s : { soilDone: { ...s.soilDone, [wallId]: true } })),
  reportSeen: {},
  markReport: (projectId) => set((s) => (s.reportSeen[projectId] ? s : { reportSeen: { ...s.reportSeen, [projectId]: true } })),
  stepperHidden: readHidden(),
  setStepperHidden: (on) => { writeHidden(on); set({ stepperHidden: on }); },
}));

/** Kısa yol: sihirbazı seçili (ya da verilen) duvar için aç — SmartDesignLayout kartı / sonuçlar paleti bunu çağırabilir */
export const openWizard = (wallId: string): void => useWizardStore.getState().open(wallId);
